import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { GenerateReport } from '@/features/reports/create'

export const Route = createFileRoute('/_authenticated/reports/new')({
  validateSearch: z.object({
    profile: z.string().max(100).optional().catch(undefined),
    instance: z.coerce.number().int().positive().optional().catch(undefined),
    opportunity: z.coerce.number().int().positive().optional().catch(undefined),
    job: z.coerce.number().int().positive().optional().catch(undefined),
  }),
  component: GenerateReport,
})
